module.exports = __webpack_public_path__ + "static/img/uz.eb1e00b8.svg";